import type { InterstateLookupTokens } from "@dealer-center/core-components";
import { useInterstateToken } from "@dealer-center/core-components";
import { useEffect, useState } from "react";
import { navMenuWidth } from "./const";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export type windowSizes =
  | "xl"
  | "lg"
  | "md"
  | "sm"
  | "xxl"
  | "3xl"
  | "xs"
  | "4xl";

export interface useWindowDimensionsInterface {
  isSmOrGreater: boolean;
  isMdOrGreater: boolean;
  isLgOrGreater: boolean;
  isXlOrGreater: boolean;
  isXxlOrGreater: boolean;
  is3xlOrGreater: boolean;
  is4xlOrGreater: boolean;
  currentSize: windowSizes;
}
export function useWindowDimensions(): useWindowDimensionsInterface {
  const [isSmOrGreater, setIsSm] = useState(false);
  const [isMdOrGreater, setIsMd] = useState(false);
  const [isLgOrGreater, setIsLg] = useState(false);
  const [isXlOrGreater, setIsXl] = useState(false);
  const [isXxlOrGreater, setIsXxl] = useState(false);
  const [is3xlOrGreater, setIs3xl] = useState(false);
  const [is4xlOrGreater, setIs4xl] = useState(false);
  const [currentSize, setCurrentSize] = useState<windowSizes>("xl");

  const getToken = useInterstateToken();

  useEffect(() => {
    function getOnlyNumbers(token: InterstateLookupTokens): number {
      const str = getToken(token);
      if (!str) return 0;
      return parseInt(str.replace(/\D/g, ""), 10);
    }
    const baseScreenXl = getOnlyNumbers("base.screen.xl");
    const baseScreenLg = getOnlyNumbers("base.screen.lg");
    const baseScreenMd = getOnlyNumbers("base.screen.md");
    const baseScreenSm = getOnlyNumbers("base.screen.sm");
    const baseScreenXxl = getOnlyNumbers("base.screen.xxl");
    const baseScreen3xl = getOnlyNumbers("base.screen.3xl");
    const baseScreen4xl = baseScreen3xl + navMenuWidth;
    function handleResize() {
      const dimensions = getWindowDimensions();
      setIsXl(dimensions.width > baseScreenXl);
      setIsLg(dimensions.width > baseScreenLg);
      setIsMd(dimensions.width > baseScreenMd);
      setIsSm(dimensions.width > baseScreenSm);
      setIsXxl(dimensions.width > baseScreenXxl);
      setIs3xl(dimensions.width > baseScreen3xl);
      setIs4xl(dimensions.width > baseScreen4xl);
      setCurrentSize(
        dimensions.width > baseScreen4xl
          ? "4xl"
          : dimensions.width > baseScreen3xl
            ? "3xl"
            : dimensions.width > baseScreenXxl
              ? "xxl"
              : dimensions.width > baseScreenXl
                ? "xl"
                : dimensions.width > baseScreenLg
                  ? "lg"
                  : dimensions.width > baseScreenMd
                    ? "md"
                    : dimensions.width > baseScreenSm
                      ? "sm"
                      : "xs"
      );
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [getToken]);

  return {
    is4xlOrGreater,
    isXlOrGreater,
    isLgOrGreater,
    isMdOrGreater,
    isSmOrGreater,
    isXxlOrGreater,
    is3xlOrGreater,
    currentSize
  };
}
